import { render, staticRenderFns } from "./ClientsCommandBar.vue?vue&type=template&id=5169686c&scoped=true"
import script from "./ClientsCommandBar.vue?vue&type=script&lang=js"
export * from "./ClientsCommandBar.vue?vue&type=script&lang=js"
import style0 from "./ClientsCommandBar.vue?vue&type=style&index=0&id=5169686c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5169686c",
  null
  
)

export default component.exports